import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import "./order.css"
import { RemarkWithToggle } from './RemarkWithToggle';
import {
  Box,
  Paper,
  Typography,
  Button,
  Chip,
  Grid,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  Alert,
  Slide,
  capitalize,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TableBody,
  TablePagination,
  alpha,


} from '@mui/material';
import { Stack } from "@mui/material";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import {

  ArrowBack as ArrowBackIcon,

} from '@mui/icons-material';
import { useLocalization } from '../../contexts/LocalizationContext';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { offerDetails } from '../../services/api';
import ImageLightbox from './ImageLightbox';
interface Order {
  id: string;
  orderNumber: string;
  sellerName: string;
  buyerName: string;
  sellerEmail: string;
  buyerEmail: string;
  sellerNumber: string | null;

  buyerNumber: string | null;

  itemName: string;
  itemPrice: number;
  status: string;
  paymentStatus: string | null;
  createdAt: string;
  ratePerHour: number;
  totalLockerCharges: number;
  lockerId?: number | null;
  orderId?: number | null;
  locker?: number | null;
  userImages: string[];   // array of image URLs
  buyerImages: string[];  // array of image URLs
  userVideo: string | null;   // single video URL
  buyerVideo: string | null;  // single video URL
  nextStep: string | null;
  offerId: string | null;
  buyerQrCode: any | null;
  sellerQrCode: any | null;
  currentStatus: string | null;
  timeDuration: string | null; // comes as string "15.00"
  bookedAt: string | null;
  paymentHistory: any;
  sellerDeleted: boolean | null;
  buyerDeleted: boolean | null

}

interface Translation {
  orders: {
    not_found: string;
    title: string;
    seller_name: string;
    customer_name: string;
    item_name: string;
    item_price: string;
    status: string;
    status_pending: string;
    status_active: string;
    status_completed: string;
    status_cancelled: string;
    payment_status: string;
    payment_pending: string;
    payment_paid: string;
    payment_refunded: string;
    rate_per_hour: string;
    created_at: string;
    duration: string;
    hours: string;
    charges: string;
    flow: {
      steps: {
        offer_sent: string;
        offer_accepted: string;
        payment_made: string;
        offer_created: string;
        payment_escrow: string;
        locker_booked_seller: string;
        seller_extended: string;
        item_placed: string;
        acknowledged_buyer: string;
        locker_booked_buyer: string;
        buyer_extended: string;
        item_picked: string;
        buyer_confirmed: string;
        seller_acknowledged: string;
        completed: string;
        buyer_unsatisfied: string;
      };
      status: {
        pending: string;
        offer_sent: string;
        offer_accepted: string;
        payment_made: string;
        in_escrow: string;
        locker_booked: string;
        extended_seller: string;
        item_stored: string;
        buyer_notified: string;
        buyer_booked: string;
        extended_buyer: string;
        in_review: string;
        completed: string;
        returned: string;
        resolved: string;
        escalated: string;
        buyer_unsatisfied: string;
      };
      notes: {
        offer_sent: string;
        offer_accepted: string;
        payment_made: string;
        offer_created: string;
        payment_escrow: string;
        locker_booked_seller: string;
        seller_extended: string;
        item_placed: string;
        acknowledged_buyer: string;
        locker_booked_buyer: string;
        buyer_extended: string;
        item_picked: string;
        buyer_confirmed: string;
        seller_acknowledged: string;
        completed: string;
        buyer_unsatisfied: string;
      };
    };
  };
  common: {
    actions: string;
    cancel: string;
    confirm: string;
  };
}

interface FlowStep {
  id: string;
  step: keyof Translation[ 'orders' ][ 'flow' ][ 'steps' ];
  status: keyof Translation[ 'orders' ][ 'flow' ][ 'status' ];
  timestamp: string;
  notes: keyof Translation[ 'orders' ][ 'flow' ][ 'notes' ];
  title?: string; // Add title for direct display
  duration?: number;
  charges?: number;
  escrowAmount?: number;
  transferTo?: 'seller' | 'buyer';
}

interface Props {
  viewOnly?: boolean;
}

const getStatusIcon = ( status: string ) => {
  switch ( status ) {
    case 'pending':
    case 'in_escrow':
      return <AccessTimeIcon color="warning" />;
    case 'locker_booked':
    case 'item_stored':
    case 'buyer_booked':
    case 'in_review':
    case 'completed':
    case 'resolved':
      return <CheckCircleIcon color="success" />;
    case 'extended_seller':
    case 'extended_buyer':
      return <InfoIcon color="info" />;
    case 'returned':
    case 'escalated':
      return <ErrorIcon color="error" />;
    default:
      return <InfoIcon color="info" />;
  }
};

export const OrderDetail: React.FC<Props> = ( { viewOnly = false } ) => {
  const { t } = useLocalization() as { t: Translation };
  const { id } = useParams<{ id: string }>();
  const [ order, setOrder ] = useState<Order | null>( null );
  const [ loading, setLoading ] = useState( true );
  const [ error, setError ] = useState<string | null>( null );
  const [ flowSteps, setFlowSteps ] = useState<FlowStep[]>( [] );
  const [ actionLoading, setActionLoading ] = useState( false );
  const [ imagePreview, setImagePreview ] = useState<string | null>( null );
  const [ imageModalOpen, setImageModalOpen ] = useState( false );
  const [ lightboxOpen, setLightboxOpen ] = useState( false );
  const [ lightboxImages, setLightboxImages ] = useState<string[]>( [] );
  const [ lightboxIndex, setLightboxIndex ] = useState( 0 );
  // } | null>( null );
  const [ confirmOpen, setConfirmOpen ] = useState( false );
  const [ confirmAction, setConfirmAction ] = useState<"locker" | "buyer" | "seller" | "SELLER_PLACED_ITEM_with_BUYER_EXTENDED_LOCKER_TIME" | "BUYER_EXTENDED_LOCKER_TIME_FOR_PLACE_ITEM" | "action" | "BUYER_SATISFIED" | "SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM" | " ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION" | "ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION" | "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" | "SELLER_UNSATISFIED" | "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED_stepSaller" | "SUPPORT_PICKED_ITEM_FROM_LOCKER" | "SUPPORT_PICKED_ITEM_FROM_SELLER" | "OFFER_FAILED" | "BUYER_UNSATISFIED" | "BUYER_PLACED_ITEM" | "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" | "SUPPORT_PICKED_ITEM_FROM_BUYER" | null>( null );
  const [ remark, setRemark ] = useState( "" );
  const [ step, setStep ] = useState<string | null>( null );
  const [ stepSeller, setStepSeller ] = useState<string | null>( null );
  const [ otp, setOtp ] = useState<any>( [] );
  const [ otpError, setOtpError ] = useState( "" );
  const [ otpModel, setOtpModel ] = useState( false )
  const [ otpContext, setOtpContext ] = useState( {
    side: "",   // buyer | seller | locker
    name: ""
  } );
  const [ showOtp, setShowOtp ] = useState( false );



  const [ toast, setToast ] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error" | "info" | "warning";
  }>( {
    open: false,
    message: "",
    severity: "warning",
  } );
  const [ page, setPage ] = React.useState( 0 );
  const [ rowsPerPage, setRowsPerPage ] = React.useState( 5 );

  const handleChangePage = ( _: unknown, newPage: number ) => {
    setPage( newPage );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage( parseInt( event.target.value, 10 ) );
    setPage( 0 );
  };

  const openLightbox = ( images: string[], index: number ) => {
    setLightboxImages( images );
    setLightboxIndex( index );
    setLightboxOpen( true );
  };



  const fetchOrderDetails = async ( orderId: string ) => {
    try {
      setLoading( true );
      setError( null );

      // Convert string ID to number and call API
      const response = await offerDetails.getOfferDetails( parseInt( orderId ) );

      if ( response.success ) {
        // Map API response to our component state
        const apiData = response.data;
        console.log( "api data selller", apiData.seller )
        // Create order object from API data
        const formatPhone = ( countryCode?: string | null, phone?: string | null ) => {
          if ( !countryCode || !phone || phone.trim() === "" ) return null;
          return `${ countryCode } ${ phone }`;
        };

        const mappedOrder: Order = {
          id: apiData.id?.toString() || orderId,
          orderNumber: apiData.id?.toString() || `ORD-${ orderId }`,

          sellerName: apiData.seller
            ? `${ apiData.seller.firstName } ${ apiData.seller.lastName }`
            : "Unknown Seller",

          buyerName: apiData.buyer
            ? `${ apiData.buyer.firstName } ${ apiData.buyer.lastName }`
            : "Unknown Buyer",

          // ✅ FIXED
          sellerNumber: apiData.seller
            ? formatPhone( apiData.seller.countryCode, apiData.seller.phoneNumber )
            : null,

          buyerNumber: apiData.buyer
            ? formatPhone( apiData.buyer.countryCode, apiData.buyer.phoneNumber )
            : null,

          sellerEmail: apiData.seller?.email ?? "Unknown Seller",
          buyerEmail: apiData.buyer?.email ?? "Unknown Buyer",

          itemName: apiData.title || "Unknown Item",
          itemPrice: parseFloat( apiData.price ) || 0,
          status: apiData.status,
          paymentStatus: apiData.paymentStatus,
          createdAt: apiData.createdAt || new Date().toISOString(),

          ratePerHour: apiData.locker?.price || 0,
          totalLockerCharges: 0,
          lockerId: apiData.lockerId ?? null,
          orderId: apiData.orderId,
          locker: apiData.locker,
          userImages: apiData.userImages,
          buyerImages: apiData.buyerImages,
          userVideo: apiData.userVideo,
          buyerVideo: apiData.buyerVideo,
          nextStep: apiData?.nextStep ?? null,
          offerId: apiData.locker?.offerId ?? null,
          sellerQrCode: apiData?.sellerQrCode ?? null,
          buyerQrCode: apiData?.buyerQrCode ?? null,
          currentStatus: apiData?.currentStatus ?? null,
          timeDuration: apiData?.timeDuration ?? null,
          bookedAt: apiData?.bookedAt ?? null,
          paymentHistory: apiData?.paymentHistory ?? [],
          buyerDeleted: apiData.buyer?.deletedAt ?? null,
          sellerDeleted: apiData.seller?.deletedAt ?? null,
        };


        setOrder( mappedOrder );

        // Store history data in descending order (newest first)
        if ( apiData.history && Array.isArray( apiData.history ) ) {
          // Debug log
          // Reverse history array without sorting by date
          const reversedHistory = [ ...apiData.history ].reverse();
          setFlowSteps( reversedHistory as any );
        } else {
          // No history from API - show empty state
          setFlowSteps( [] );
        }

      } else {
        setError( response.message || 'Failed to load order details' );
      }
    } catch ( err ) {
      console.error( 'Error fetching order details:', err );
      setError( 'Failed to load order details' );
    } finally {
      setLoading( false );
    }
  };
  const hasMedia =
    ( order?.userImages?.length ?? 0 ) > 0 ||
    ( order?.buyerImages?.length ?? 0 ) > 0 ||
    !!order?.userVideo ||
    !!order?.buyerVideo;
  const handleSupportPickup = async () => {
    if ( !order ) return;
    setActionLoading( true );
    // setActionError( null );
    try {
      const offerId = Number( order.id );
      const lockerId = order.lockerId;
      // const orderId = order.orderId?.toString() || " ";
      // if (!lockerId&&orderId) {
      //   setActionError('Locker ID not found.');
      //   setActionLoading(false);
      //   return;
      // }
      await offerDetails.supportSystemPickupItemFromLocker( offerId, lockerId, remark );

      setActionLoading( false );
      fetchOrderDetails( order.id );
      setRemark( "" )
    } catch ( err: any ) {
      // setActionError( err?.message || 'Action failed' );
      setActionLoading( false );
    }
  };
  const navigate = useNavigate()
  const handleCloseImageModal = () => {
    setImageModalOpen( false );
    setImagePreview( null );
  };

  const handleTransfer = async () => {
    if ( !order ) return;
    setActionLoading( true );
    // setActionError( null );
    try {

      const offerId = Number( order.id );
      // const lockerId = order.lockerId;
      // const orderId = order.orderId?.toString() || " ";
      const status = confirmAction === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED_stepSaller" ? "refund" : "tranfer"
      // if (!lockerId&&orderId) {
      //   setActionError('Locker ID not found.');
      //   setActionLoading(false);
      //   return;
      // }

      const res = await offerDetails.supportrefundTransferAmount(
        offerId,
        remark,
        status
      );

      if ( confirmAction === "ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION" || confirmAction === "BUYER_SATISFIED" || confirmAction === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" ) {
        setToast( {
          open: true,
          message: res?.message || "Action completed successfully!",
          severity: "warning",
        } );
      }
      setActionLoading( false );
      fetchOrderDetails( order.id );
      setRemark( "" )
    } catch ( err: any ) {
      // setActionError( err?.message || 'Action failed' );
      setActionLoading( false );
    }
  };



  const handleCloseToast = () => {
    setToast( ( prev ) => ( { ...prev, open: false } ) );
  };



  const handleReturnToseller = async () => {
    if ( !order ) return;

    setActionLoading( true );
    // setActionError( null );

    try {

      const offerId = Number( order.id );
      const orderId = order.orderId?.toString() || "0";
      const transactionCode = Number( otp );

      const status = "ITEM_RETURN_TO_SELLER_AFTER_INVESTIGATION";

      if ( !orderId ) {
        // setActionError( "Order ID not found." );
        setActionLoading( false );
        return;
      }

      const res = await offerDetails.sellerTakeItemSellerDeclined(
        offerId,
        remark,
        status,
        transactionCode,


      );

      if ( !res.success ) {
        setOtpError( res.message );
        return; // ⛔ stop here if OTP is wrong
      }


      setRemark( "" )

      setOtpModel( false )
      setOtp( "" )
      fetchOrderDetails( order.id );
    } catch ( err: any ) {
      setOtpError( err );
      // setActionError( err?.message || "Action failed" );
    } finally {
      setActionLoading( false );
    }
  };

  const handleReturnToBuyer = async () => {

    if ( !order ) return;



    // setActionError( null );


    if ( !otp ) {
      setOtpError( "Please enter OTP" );

      return;
    }
    if ( otp.length < 6 ) {
      setOtpError( "Please enter correct otp" );

      return;
    }
    setActionLoading( true );

    try {

      const offerId = Number( order.id );
      const orderId = order.orderId?.toString() || "0";
      const transactionCode = Number( otp );
      const status = "ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION";

      if ( !orderId ) {
        // setActionError( "Order ID not found." );
        setActionLoading( false );
        return;
      }

      const res = await offerDetails.sellerTakeItemSellerDeclined(
        offerId,
        remark,
        status,
        transactionCode

      );

      if ( !res.success ) {
        setOtpError( res.message );
        return; // ⛔ stop here if OTP is wrong
      }

      setRemark( "" );
      fetchOrderDetails( order.id );
      setOtpModel( false );




    } catch ( err: any ) {
      console.error( err );
      setOtpError( err );
      // setActionError( err?.message || "Action failed" );
    } finally {
      setActionLoading( false );
    }
  };



  // Call API when component mounts or ID changes
  useEffect( () => {
    if ( id ) {
      fetchOrderDetails( id );
    }
  }, [ id ] );

  useEffect( () => {
    if ( !flowSteps || flowSteps.length === 0 ) return;

    // Check if anywhere in history the step is BUYER_UNSATISFIED
    const hasBuyerUnsatisfied = flowSteps.some(
      item => item.step?.toLowerCase() === "buyer_unsatisfied"
    );

    if ( hasBuyerUnsatisfied ) {
      setStep( "BUYER_UNSATISFIED" ); // forced override
    } else {
      // otherwise always set last step
      setStep( flowSteps[ flowSteps.length - 1 ].step );
    }
  }, [ flowSteps ] );

  useEffect( () => {
    if ( !flowSteps || flowSteps.length === 0 ) return;

    // Check if anywhere in history the step is Seller_UNSATISFIED

    const hasSellerUnsatisfied = flowSteps.some(
      item => item.step?.toLowerCase() === "seller_unsatisfied"
    );

    if ( hasSellerUnsatisfied ) {
      setStepSeller( "SELLER_UNSATISFIED" ); // forced override
    } else {
      // otherwise always set last step
      setStepSeller( flowSteps[ flowSteps.length - 1 ].step );
    }
  }, [ flowSteps ] );






  useEffect( () => {
    if ( id ) {
      fetchOrderDetails( id );
    }
  }, [ id ] );

  if ( loading ) {
    return (
      <Box sx={ { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' } }>
        <CircularProgress />
      </Box>
    );
  }

  if ( error ) {
    return (
      <Box sx={ { p: 3 } }>
        <Typography variant="h6" color="error">
          { error }
        </Typography>
        <Button onClick={ () => fetchOrderDetails( id! ) } sx={ { mt: 2 } }>
          Retry
        </Button>
      </Box>
    );
  }

  if ( !order ) {
    return (
      <Box sx={ { p: 3 } }>
        <Typography>{ t.orders.not_found }</Typography>
      </Box>
    );
  }

  const statusMap: Record<
    "PAYMENT_COMPLETED" | "PAYMENT_IN_ESCROW" | "REFUND_TO_BUYER" | "PAYMENT_TO_SELLER",
    string
  > = {
    PAYMENT_COMPLETED: "Payment in escrow",
    PAYMENT_IN_ESCROW: "Payment in escrow",
    REFUND_TO_BUYER: "Payment refund to buyer",
    PAYMENT_TO_SELLER: "Payment transfer to seller",
  };

  // bookedAt = order.bookedAt (ISO format string)
  // duration = locker time in minutes

  const isTimeExpired = ( bookedAt?: string | null, durationMinutes?: string | null ) => {
    if ( !bookedAt || !durationMinutes ) return false;

    const start = new Date( bookedAt );

    // Convert string "15.00" → number 15
    const duration = Number( durationMinutes );

    if ( isNaN( duration ) ) return false; // safety check

    const expireTime = new Date( start.getTime() + duration * 60 * 1000 );
    const now = new Date();

    return now > expireTime;
  };

  const getExpiryTime = ( bookedAt: string, durationMinutes: string ) => {
    if ( !bookedAt || !durationMinutes ) return null;

    const start = new Date( bookedAt );
    const expire = new Date( start.getTime() + Number( durationMinutes ) * 60 * 1000 );

    return expire; // returns full date object
  };
  const formatTime = ( date: Date ) => {
    const datePart = date.toLocaleDateString( "en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    } );

    const timePart = date.toLocaleTimeString( "en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    } );

    return `${ datePart } at ${ timePart }`; // "at" is the custom separator
  };

  const expiry = order?.bookedAt && order?.timeDuration
    ? getExpiryTime( order.bookedAt, order.timeDuration )
    : null;

  const paginatedPayments = order.paymentHistory?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  // console.log( "seller number is ", order?.sellerNumber )
  // console.log( "seller number is ", order?.sellerNumber.length )
  console.log( order?.sellerNumber, typeof order?.sellerNumber );


  return (
    <>
      <Box sx={ { p: 3 } }>

        <Box display="flex" alignItems="center" mb={ 2 } gap={ 2 }>
          <Button
            variant="outlined"
            startIcon={ <ArrowBackIcon /> }
            onClick={ () => navigate( '/orders' ) }
          >
            Back
          </Button>

          <Typography variant="h4">
            { t.orders.title } - { order.orderNumber }
          </Typography>
        </Box>

        <Paper sx={ { mt: 3, p: 3 } }>
          <Grid container spacing={ 2 }>
            <Grid item xs={ 12 } md={ 6 }>

              <Typography variant="subtitle1">
                <strong>{ t.orders.seller_name }:</strong> { capitalize( order.sellerName ) } { order.sellerDeleted && "( Deactivated) " }
              </Typography>
              <Typography variant="subtitle1" >
                <strong>{ "Seller Email" }:</strong> { ' ' }
                {/* <Chip label={ order.currentStatus } color={ getStatusColor( order.status ) } /> */ }
                { order?.sellerEmail || "N/A" }
              </Typography>
              <Stack spacing={ 2 }>

                <Typography variant="subtitle1">
                  <strong>Seller Phone Number:</strong>{ " " }
                  { order?.sellerNumber ?? "N/A" }

                </Typography>



                <Typography variant="subtitle1">
                  <strong>{ t.orders.item_name }:</strong> { order.itemName || "N/A" }
                </Typography>
              </Stack>
              <Typography variant="subtitle1">
                <strong>{ t.orders.item_price }:</strong> ${ order.itemPrice.toFixed( 2 ) }
              </Typography>
              {/* <Typography variant="subtitle1">
                <strong>{ "Order Id" }:</strong> { order.orderId }
              </Typography> */}
              <Typography variant="subtitle1">
                <strong>{ t.orders.payment_status }:</strong>{ " " }
                {/* <Chip
                label={
                  order.paymentStatus &&
                    statusMap[ order.paymentStatus as keyof typeof statusMap ]
                    ? statusMap[ order.paymentStatus as keyof typeof statusMap ]
                    : "Pending"
                }
                color={ getPaymentStatusColor( order.paymentStatus ) }
              /> */}
                { order.paymentStatus &&
                  statusMap[ order.paymentStatus as keyof typeof statusMap ]
                  ? statusMap[ order.paymentStatus as keyof typeof statusMap ]
                  : "Pending"
                }
              </Typography>
              <Stack spacing={ 2 }>
                <Typography variant="subtitle1">
                  <strong>{ "Order Created At " }:</strong>{ " " }
                  { ( () => {
                    const dateObj = new Date( order.createdAt );

                    const date = dateObj.toLocaleDateString( "en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    } );

                    const time = dateObj.toLocaleTimeString( "en-IN", {
                      hour: "2-digit",
                      minute: "2-digit",
                    } );

                    return `${ date } at ${ time }`; // "at" is your custom separator
                  } )() }
                </Typography>

                <Typography variant="subtitle1" >
                  <strong>{ t.orders.status }:</strong> { ' ' }
                  {/* <Chip label={ order.currentStatus } color={ getStatusColor( order.status ) } /> */ }
                  { order.currentStatus }
                </Typography>
              </Stack>
              <Typography variant="subtitle1">
                <strong>{ "Next Step" }: </strong>
                { order.nextStep }{ " " }
                <>
                  {/* new conditions added */ }
                  {/* OFFER_FAILED */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "OFFER_FAILED" ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "OFFER_FAILED" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Collect the item from the locker" }
                      </Button>
                    ) }
                  {/* BUYER_UNSATISFIED */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&

                      ( order?.status === "BUYER_UNSATISFIED" ) &&
                      isTimeExpired( order?.bookedAt, order?.timeDuration ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "BUYER_UNSATISFIED" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Collect item from the buyer" }
                      </Button>
                    ) }
                  {/* BUYER_PLACED_ITEM */ }
                  {
                    ( order?.lockerId !== null &&
                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      order?.status === "BUYER_PLACED_ITEM" &&
                      isTimeExpired( order?.bookedAt, order?.timeDuration )

                    ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "BUYER_PLACED_ITEM" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Collect item from the locker" }
                      </Button>
                    )
                  }

                  {/* ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      step === "BUYER_UNSATISFIED" &&
                      stepSeller !== "SELLER_UNSATISFIED" &&
                      ( order?.status === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "transfer payment to seller" }
                      </Button>
                    ) }

                  {/* SUPPORT_PICKED_ITEM_FROM_BUYER */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SUPPORT_PICKED_ITEM_FROM_BUYER" ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "SUPPORT_PICKED_ITEM_FROM_BUYER" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Return item to buyer or seller" }
                      </Button>
                    ) }
                  {/* SUPPORT_PICKED_ITEM_FROM_LOCKER */ }
                  {/* {
                  ( order?.lockerId !== null &&

                    order?.sellerQrCode === null &&
                    order?.buyerQrCode === null &&
                    ( order?.status === "SUPPORT_PICKED_ITEM_FROM_LOCKER" ) ) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={ () => {
                        setConfirmAction( "SUPPORT_PICKED_ITEM_FROM_LOCKER" );
                        setConfirmOpen( true );
                      } }
                      disabled={ actionLoading }
                    >
                      { actionLoading ? "Processing..." : "Support picked item from locker" }
                    </Button>
                  ) } */}
                  {/* SELLER_UNSATISFIED */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SELLER_UNSATISFIED" ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "SELLER_UNSATISFIED" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Collect item from the seller" }
                      </Button>
                    ) }
                  {/* ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED */ }

                  {
                    ( order?.lockerId !== null &&
                      stepSeller === "SELLER_UNSATISFIED" &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED_stepSaller" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "transfer payment to buyer" }
                      </Button>
                    ) }

                  {/* SELLER_UNSATISFIED */ }
                  {/* {
                  ( order?.lockerId !== null &&

                    order?.sellerQrCode === null &&
                    order?.buyerQrCode === null &&
                    ( order?.status === "SELLER_UNSATISFIED" ) ) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={ () => {
                        setConfirmAction( "SELLER_UNSATISFIED" );
                        setConfirmOpen( true );
                      } }
                      disabled={ actionLoading }
                    >
                      { actionLoading ? "Processing..." : " Collect item from the seller" }
                    </Button>
                  ) } */}

                  {/* SUPPORT_PICKED_ITEM_FROM_LOCKER */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SUPPORT_PICKED_ITEM_FROM_LOCKER" ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "SUPPORT_PICKED_ITEM_FROM_LOCKER" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Retunr item to seller or buyer" }
                      </Button>
                    ) }
                  {/* SUPPORT_PICKED_ITEM_FROM_SELLER */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SUPPORT_PICKED_ITEM_FROM_SELLER" ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "SUPPORT_PICKED_ITEM_FROM_SELLER" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Retunr item to seller or buyer" }
                      </Button>
                    ) }

                  {/* ITEM__RETURN_TO_BUYER_AFTER_INVESTIGATION */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      // step === "BUYER_UNSATISFIED" &&
                      order.paymentStatus !== "PAYMENT_TO_SELLER" &&
                      // stepSeller !== "SELLER_UNSATISFIED" &&
                      ( order?.status === "ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION" ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "transfer payment to seller" }
                      </Button>
                    ) }
                  {/* SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&

                      ( order?.status === "SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM" ) &&
                      isTimeExpired( order?.bookedAt, order?.timeDuration ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Collect item to from locker" }
                      </Button>
                    ) }

                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      // step === "BUYER_UNSATISFIED" &&
                      order.paymentStatus !== "PAYMENT_TO_SELLER" &&
                      // stepSeller !== "SELLER_UNSATISFIED" &&
                      ( order?.status === "BUYER_SATISFIED" ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "BUYER_SATISFIED" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "transfer payment to seller" }
                      </Button>
                    ) }
                  {/* BUYER_EXTENDED_LOCKER_TIME_FOR_PLACE_ITEM */ }
                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&

                      ( order?.status === "BUYER_EXTENDED_LOCKER_TIME_FOR_PLACE_ITEM" ) &&
                      isTimeExpired( order?.bookedAt, order?.timeDuration ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "BUYER_EXTENDED_LOCKER_TIME_FOR_PLACE_ITEM" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Collect item to from buyer" }
                      </Button>
                    ) }
                  {/* SELLER_PLACED_ITEM , BUYER_EXTENDED_LOCKER_TIME */ }

                  {
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&

                      ( order?.status === "SELLER_PLACED_ITEM" || order?.status === "BUYER_EXTENDED_LOCKER_TIME" ) &&
                      isTimeExpired( order?.bookedAt, order?.timeDuration ) ) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => {
                          setConfirmAction( "SELLER_PLACED_ITEM_with_BUYER_EXTENDED_LOCKER_TIME" );
                          setConfirmOpen( true );
                        } }
                        disabled={ actionLoading }
                      >
                        { actionLoading ? "Processing..." : "Collect item from the locker" }
                      </Button>
                    ) }

                  {/* new conditions added */ }
                  {/* --------------------------------------------- */ }
                  {/* 1️⃣ Support Take Item from Locker */ }
                  {/* --------------------------------------------- */ }

                  {/* {
                  ( order?.lockerId !== null &&
                    Number( order?.id ) === Number( order?.offerId ) &&
                    order?.sellerQrCode === null &&
                    order?.buyerQrCode === null &&
                    ( order?.status === "OFFER_FAILED" ||
                      order?.status === "BUYER_PLACED_ITEM" ) ) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={ () => {
                        setConfirmAction( "locker" );
                        setConfirmOpen( true );
                      } }
                      disabled={ actionLoading }
                    >
                      { actionLoading ? "Processing..." : "Collect the item from the locker" }
                    </Button>
                  ) } */}

                  {/* 2️⃣ Support Take Item from Buyer */ }
                  {/* { ( order?.lockerId !== null &&
                  Number( order?.id ) !== Number( order?.offerId ) &&
                  order?.sellerQrCode === null &&
                  order?.buyerQrCode === null &&
                  ( order?.status === "BUYER_UNSATISFIED" ||
                    order?.status === "SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM" ) ) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={ () => {
                        setConfirmAction( "buyer" );
                        setConfirmOpen( true );
                      } }
                      disabled={ actionLoading }
                    >
                      { actionLoading ? "Processing..." : "Collect the item from the  buyer" }
                    </Button>
                  )
                } */}

                  {/* 3️⃣ Seller Take Item from Support */ }
                  {/* { (
                  order?.lockerId !== null &&
                  order?.id !== order?.offerId &&
                  order?.sellerQrCode === null &&
                  order?.buyerQrCode === null &&
                  (
                    order?.status === "ITEM_PICKED_BY_SUPPORT_FROM_BUYER" ||
                    order?.status === "SUPPORT_PICKED_ITEM_FROM_LOCKER"
                  )
                ) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={ () => {
                        setConfirmAction( "seller" );
                        setConfirmOpen( true );
                      } }
                      disabled={ actionLoading }
                    >
                      { actionLoading ? "Processing..." : "Return item to seller " }
                    </Button>
                  ) } */}

                  {/* 2️⃣ This is the final Action*/ }
                  {/* --------------------------------------------- */ }
                  {/* { ( order?.lockerId !== null &&
                  Number( order?.id ) !== Number( order?.offerId ) &&
                  order?.sellerQrCode === null &&
                  order?.buyerQrCode === null &&
                  ( order?.status === "SELLER_DECLINE" ) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={ () => {
                        setConfirmAction( "action" );
                        setConfirmOpen( true );
                      } }
                      disabled={ actionLoading }
                    >
                      { actionLoading ? "Processing..." : "Final Action" }
                    </Button>
                  ) )
                } */}

                  {/* ------------------------------------------------ */ }
                  {/* ⭐ Fallback Text — Show ONLY if no button appears */ }
                  {/* ------------------------------------------------ */ }
                  { !(
                    // 1st button condition
                    ( order?.lockerId !== null &&
                      Number( order?.id ) === Number( order?.offerId ) &&
                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "OFFER_FAILED" ||
                        order?.status === "BUYER_PLACED_ITEM" ) ) ||

                    // 2nd button condition
                    ( order?.lockerId !== null &&
                      Number( order?.id ) !== Number( order?.offerId ) &&
                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "BUYER_UNSATISFIED" ||
                        order?.status === "SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM" ) ) ||

                    // 3rd button condition
                    ( order?.lockerId !== null &&
                      Number( order?.id ) !== Number( order?.offerId ) &&
                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "ITEM_PICKED_BY_SUPPORT_FROM_BUYER" ||
                        order?.status === "SUPPORT_PICKED_ITEM_FROM_LOCKER" ) ) ||

                    // 4rd button condition
                    ( order?.lockerId !== null &&
                      Number( order?.id ) !== Number( order?.offerId ) &&
                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SELLER_DECLINE" ) )
                    ||

                    // New Buttons
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "OFFER_FAILED" ) )
                    ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "BUYER_UNSATISFIED" ) )
                    ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "BUYER_PLACED_ITEM" ) )
                    ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" ) )
                    ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SUPPORT_PICKED_ITEM_FROM_BUYER" ) )
                    ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SUPPORT_PICKED_ITEM_FROM_BUYER" ) ) ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SUPPORT_PICKED_ITEM_FROM_LOCKER" ) ) ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SELLER_UNSATISFIED" ) ) ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" ) ) ||

                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SELLER_UNSATISFIED" ) ) ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SUPPORT_PICKED_ITEM_FROM_LOCKER" ) ) ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      ( order?.status === "SUPPORT_PICKED_ITEM_FROM_SELLER" ) ) ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&
                      // step === "BUYER_UNSATISFIED" &&
                      order.paymentStatus !== "PAYMENT_TO_SELLER" &&
                      // stepSeller !== "SELLER_UNSATISFIED" &&
                      ( order?.status === "ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION" ) ) ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&

                      ( order?.status === "SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM" ) &&
                      isTimeExpired( order?.bookedAt, order?.timeDuration ) ) ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&

                      ( order?.status === "BUYER_EXTENDED_LOCKER_TIME_FOR_PLACE_ITEM" ) &&
                      isTimeExpired( order?.bookedAt, order?.timeDuration ) ) ||
                    ( order?.lockerId !== null &&

                      order?.sellerQrCode === null &&
                      order?.buyerQrCode === null &&

                      ( order?.status === "SELLER_PLACED_ITEM" || order?.status === "BUYER_EXTENDED_LOCKER_TIME" ) &&
                      isTimeExpired( order?.bookedAt, order?.timeDuration ) )

                  ) && (

                      order?.nextStep ? " " : "No further action"

                    ) }

                </>

              </Typography>


            </Grid>
            <Grid item xs={ 12 } md={ 6 }>


              <Typography variant="subtitle1">
                <strong>{ "Buyer Name " }:</strong> { order.buyerName } { order.buyerDeleted && ( "Deactivated" ) }
              </Typography>
              <Typography variant="subtitle1" >
                <strong>{ "Buyer Email" }:</strong> { ' ' }
                {/* <Chip label={ order.currentStatus } color={ getStatusColor( order.status ) } /> */ }
                { order?.buyerEmail || "N/A" }
              </Typography>
              <Stack spacing={ 2 }>
                <Typography variant="subtitle1" >
                  <strong>{ "Buyer Phone Number" }:</strong> { ' ' }
                  {/* <Chip label={ order.currentStatus } color={ getStatusColor( order.status ) } /> */ }
                  { order?.buyerNumber ?? "N/A" }

                </Typography>




                <Typography variant="subtitle1">
                  <strong>{ "Locker Id" }:</strong> { order.lockerId || "N/A" }
                </Typography>
              </Stack>

              { expiry && (
                <Typography variant="subtitle1">
                  <strong>{ "Locker Expiration Time" }:</strong> { formatTime( expiry ) }
                </Typography> ) }

              { order.ratePerHour > 0 && (
                <Typography variant="subtitle1" >
                  <strong>Locker Rate:</strong> ${ Number( order.ratePerHour ).toFixed( 2 ) } / hour
                </Typography>
              ) }
              {/* <Typography variant="subtitle1">
              <strong>Total Locker Charges:</strong> ${order.totalLockerCharges.toFixed(2)}
            </Typography> */}


            </Grid>
          </Grid>
        </Paper>

        <Paper sx={ { mt: 3, p: 3 } }>
          <Grid container spacing={ 2 }>
            < Grid item xs={ 12 } md={ hasMedia ? 6 : 12 }>
              <Typography variant="h6" gutterBottom>
                Order Flow Timeline
              </Typography>
              { flowSteps.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={ { textAlign: 'center', py: 3 } }>
                  No timeline data available for this order. The order flow will be displayed here once actions are taken.
                </Typography>
              ) : (
                <Timeline>
                  { flowSteps.map( ( historyItem: any, index: number ) => {
                    const remark = historyItem?.meta?.remark || "";
                    const words = remark.trim().split( /\s+/ );
                    const isLong = words.length > 20;

                    const trimmedRemark = isLong ? words.slice( 0, 20 ).join( " " ) + "..." : remark;
                    return (

                      <TimelineItem key={ index }>

                        <TimelineOppositeContent color="text.secondary">
                          { new Date( historyItem.date ).toLocaleString() }
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot>
                            { getStatusIcon( historyItem.status ) }
                          </TimelineDot>
                          { index < flowSteps.length - 1 && <TimelineConnector /> }
                        </TimelineSeparator>
                        <TimelineContent>
                          <Typography variant="subtitle1" className='all_cusWord'>
                            { historyItem.step }
                          </Typography>
                          <Typography variant="body2" color="text.secondary" className="all_cusWord">
                            { historyItem?.title?.admin }
                          </Typography>

                          {/* Remark */ }
                          { remark && (
                            <RemarkWithToggle remark={ remark } trimmedRemark={ trimmedRemark } isLong={ isLong } />
                          ) }

                          <Chip
                            label={ historyItem.status }
                            size="small"
                            sx={ { mt: 1 } }
                          />
                          {/* Show Action button only for the first item if step is OFFER_FAILED */ }
                          {/* { index === 0 && historyItem.step === 'OFFER_FAILED' && (
                        <Box sx={ { mt: 2 } }>
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={ handleSupportPickup }
                            disabled={ actionLoading }
                          >
                            { actionLoading ? 'Processing...' : 'Action' }
                          </Button>
                          { actionError && (
                            <Typography color="error" variant="body2" sx={ { mt: 1 } }>{ actionError }</Typography>
                          ) }
                        </Box>
                      ) } */}
                          {/* { index === 0 &&
                        ( historyItem.step === 'REFUND_TO_BUYER' || historyItem.step === 'BUYER_PLACED_ITEM' ) &&
                        Number( order.id ) !== order.lockerId && order.locker !== null
                        && (
                          <Box sx={ { mt: 2 } }>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={ handleSellerTakeItemFromSupportSystem }
                              disabled={ actionLoading }
                            >
                              { actionLoading ? 'Processing...' : 'Seller pickup item from support' }
                            </Button>
                            { actionError && (
                              <Typography color="error" variant="body2" sx={ { mt: 1 } }>
                                { actionError }
                              </Typography>
                            ) }
                          </Box>
                        )
                      } */}

                          {/* Show Seller Take Item button only for the last item if step is BUYER_UNSATISFIED */ }
                          {/* { index === 0 && historyItem.step === 'BUYER_UNSATISFIED' && (
                        <Box sx={ { mt: 2 } }>

                          <Button
                            variant="contained"
                            color="primary"
                            onClick={ handleSupportPickup }
                            disabled={ actionLoading }
                          >
                            { actionLoading ? 'Processing...' : 'Buyer Submit Item to Support System' }
                          </Button>
                          { actionError && (
                            <Typography color="error" variant="body2" sx={ { mt: 1 } }>{ actionError }</Typography>
                          ) }
                        </Box>
                      ) }
                      { index === 0 && ( historyItem.step === 'ITEM_PICKED_BY_SUPPORT_FROM_BUYER' || historyItem.step === 'SUPPORT_PICKED_ITEM_FROM_LOCKER' ) && (
                        <Box sx={ { mt: 2 } }>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={ handleSellerTakeItemFromSupportSystem }
                            disabled={ actionLoading }
                          >
                            { actionLoading ? 'Processing...' : 'Seller Take Item from Support System' }
                          </Button>
                          { actionError && (
                            <Typography color="error" variant="body2" sx={ { mt: 1 } }>{ actionError }</Typography>
                          ) }
                        </Box>
                      ) } */}
                        </TimelineContent>
                      </TimelineItem>
                    )
                  } ) }
                </Timeline>
              ) }
            </Grid>

            { hasMedia && (
              <Grid item xs={ 12 } md={ 6 }>
                <Typography variant="h6" gutterBottom>
                  Media
                </Typography>

                {/* User Media */ }
                { ( order?.userImages?.length > 0 || order?.userVideo ) && (
                  <Box sx={ { mb: 3 } }>
                    <Typography variant="subtitle1" sx={ { fontWeight: 600, mb: 1 } }>
                      Media Uploaded By Seller
                    </Typography>

                    {/* User Images */ }
                    <Box sx={ { display: "flex", gap: "1", flexWrap: "wrap" } } className="odrCusboximgVieW">
                      { order?.userImages?.map( ( img, i ) => (
                        <div className="customOrderImage">
                          <img
                            key={ i }
                            src={ img }
                            alt="user-media"
                            className="w-100"
                            onClick={ () => openLightbox( order.userImages, i ) }
                            style={ { cursor: "pointer" } }></img>

                        </div>
                      ) ) }

                    </Box>

                    {/* User Video */ }
                    { order?.userVideo && (
                      <div className="videoheightWX" style={ { marginTop: "10px" } }>
                        <video controls loop width={ 100 } height={ 100 }
                          src={ order.userVideo }
                        />
                      </div>

                    ) }
                  </Box>
                ) }

                {/* Buyer Media */ }
                { ( order?.buyerImages?.length > 0 || order?.buyerVideo ) && (
                  <Box>
                    <Typography variant="subtitle1" sx={ { fontWeight: 600, mb: 1 } }>
                      Media Uploaded By Buyer
                    </Typography>

                    {/* Buyer Images */ }
                    <Box sx={ { display: "flex", gap: 1, flexWrap: "wrap" } } className="odrCusboximgVieW">
                      { order?.buyerImages?.map( ( img, i ) => (
                        <div className="customOrderImage">
                          <img
                            key={ i }
                            src={ img }
                            alt="buyer-media"
                            className="w-100"
                            onClick={ () => openLightbox( order.buyerImages, i ) }
                            style={ { cursor: "pointer" } }
                          />
                        </div>
                      ) ) }

                    </Box>

                    {/* Buyer Video */ }

                    { order?.buyerVideo && (
                      <div className="videoheightWX" style={ { marginTop: "10px" } }>
                        <video controls loop width={ 100 } height={ 100 }
                          src={ order.buyerVideo }
                        />
                      </div>

                    ) }

                  </Box>
                ) }
              </Grid>
            ) }

          </Grid>
        </Paper>
        { order?.paymentHistory?.length > 0 && (
          <Box sx={ { mt: 5 } }>
            <Typography variant="h6" gutterBottom>
              Payment History
            </Typography>

            <TableContainer
              component={ Paper }
              sx={ {
                mt: 2,
                borderRadius: 3,
                overflow: "hidden",
              } }
            >
              <Table>
                <TableHead>
                  <TableRow
                    sx={ {
                      backgroundColor: "primary.main",
                      "& th": {
                        color: "white",
                        fontWeight: 600,
                        fontSize: "0.875rem",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      },
                    } }
                  >
                    <TableCell align="center">ID</TableCell>
                    <TableCell align="center">Type</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Amount</TableCell>
                    <TableCell align="center">Net Amount</TableCell>
                    <TableCell align="center">Stripe Fee</TableCell>
                    <TableCell align="center">Date</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  { paginatedPayments.map( ( ph: any ) => (
                    <TableRow
                      key={ ph.id }
                      sx={ {
                        "&:hover": {
                          backgroundColor: ( theme ) =>
                            alpha( theme.palette.primary.main, 0.04 ),
                        },
                        transition: "background-color 0.2s ease",
                      } }
                    >
                      <TableCell align="center">{ ph.id }</TableCell>

                      <TableCell align="center">
                        <Chip label={ ph.paymentType } size="small" color="primary" />
                      </TableCell>

                      <TableCell align="center">
                        <Chip
                          label={ ph.status }
                          size="small"
                          color={ ph.status.includes( "REFUND" ) ? "warning" : "success" }
                          sx={ { fontWeight: 600 } }
                        />
                      </TableCell>

                      <TableCell align="center">${ ph.amount }</TableCell>
                      <TableCell align="center">${ ph.netAmount }</TableCell>
                      <TableCell align="center">${ ph.stripeFee }</TableCell>

                      <TableCell align="center">
                        { ( () => {
                          const dateObj = new Date( ph.createdAt );

                          const date = dateObj.toLocaleDateString( "en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          } );

                          const time = dateObj.toLocaleTimeString( "en-IN", {
                            hour: "2-digit",
                            minute: "2-digit",
                          } );

                          return `${ date } at ${ time }`;
                        } )() }
                      </TableCell>
                    </TableRow>
                  ) ) }
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                rowsPerPageOptions={ [ 5, 10, 25 ] }
                count={ order.paymentHistory.length }
                rowsPerPage={ rowsPerPage }
                page={ page }
                onPageChange={ handleChangePage }
                onRowsPerPageChange={ handleChangeRowsPerPage }
                sx={ {
                  borderTop: "1px solid",
                  borderColor: "divider",
                } }
              />
            </TableContainer>

            {/* ✅ Pagination Below Table */ }

          </Box>
        ) }

        {/* <Dialog
        open={ model }
        onClose={ () => showModel( false ) }
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={ {
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
            },
            color: 'white',
            textTransform: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            py: 2.5,
            px: 3,
            fontSize: "20px",
            fontWeight: 600
          } }
        >
          Confirm Action
        </DialogTitle>

        <DialogContent sx={ { paddingTop: "20px" } }>
          <Typography >
            { getModalMessage() }
          </Typography>
        </DialogContent>

        <DialogActions sx={ { px: 3, pb: 2 } }>
          <Button
            onClick={ () => showModel( false ) }
            variant="outlined"
            disabled={ actionLoading }
            sx={ {
              minWidth: 100,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600
            } }
          >
            Cancel
          </Button>

          <Button
            onClick={ handleConfirmAction }
            variant="contained"
            disabled={ actionLoading }
            color="success"
            sx={ {
              minWidth: 120,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600
            } }
          >
            { actionLoading ? <CircularProgress size={ 24 } /> : "Confirm" }
          </Button>
        </DialogActions>
      </Dialog> */}
        <Dialog
          open={ imageModalOpen }
          onClose={ handleCloseImageModal }
          maxWidth="lg"
          fullWidth
          PaperProps={ {
            style: { background: "rgba(0,0,0,0.9)" }
          } }
        >
          <img
            src={ imagePreview || "" }
            alt="preview"
            style={ {
              width: "100%",
              height: "auto",
              maxHeight: "90vh",
              objectFit: "contain",
              display: "block",
              margin: "auto",
              borderRadius: "10px"
            } }
          />
        </Dialog>

        <ImageLightbox
          open={ lightboxOpen }
          images={ lightboxImages }
          startIndex={ lightboxIndex }
          onClose={ () => setLightboxOpen( false ) }
        />

        <Dialog
          open={ confirmOpen }
          onClose={ () => {
            setConfirmOpen( false )
            setRemark( "" )
            setOtpError( "" )
            setOtp( "" )
          } }
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={ {
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
              },
              '&:disabled': {
                background: 'grey.400',
                color: 'grey.600'
              },
              textTransform: 'none',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              py: 2.5,
              px: 3
            } }
          >
            {/* { confirmAction === "locker" && "Collect Item From Locker" }
          { confirmAction === "buyer" && "Collect Item From Buyer" }
          { confirmAction === "seller" && "Return Item To Seller" }
          { confirmAction === "action" && "Take Final Action" } */}
            { confirmAction === "OFFER_FAILED" && "Collect item from the locker" }
            { confirmAction === "BUYER_UNSATISFIED" && "Collect item from the buyer" }
            { confirmAction === "BUYER_PLACED_ITEM" && "Collect item from the locker " }
            { confirmAction === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" && "Transfer payment" }
            { confirmAction === "SUPPORT_PICKED_ITEM_FROM_BUYER" && "Return Item" }

            { confirmAction === "SELLER_UNSATISFIED" && "Collect Item" }
            { confirmAction === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED_stepSaller" && "Transfer payment" }
            { confirmAction === "SUPPORT_PICKED_ITEM_FROM_LOCKER" && "Return Item" }
            { confirmAction === "SUPPORT_PICKED_ITEM_FROM_SELLER" && "Return Item" }
            { confirmAction === "ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION" && "Transfer payment" }

            { confirmAction === "SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM" && "Collect Item" }
            { confirmAction === "BUYER_SATISFIED" && "Transfer payment" }
            { confirmAction === "BUYER_EXTENDED_LOCKER_TIME_FOR_PLACE_ITEM" && "Collect Item" }

          </DialogTitle>

          <DialogContent style={ { paddingTop: "20px" } }>
            <Typography>
              {/* { confirmAction === "locker" &&
              "Are you sure you want to collect the item from the locker?" }

            { confirmAction === "buyer" &&
              "Are you sure you want to collect the item from the buyer?" }

            { confirmAction === "seller" &&
              "Are you sure you want to return the item to the seller?" }

            { confirmAction === "action" &&
              "Are you sure you want to take final action" } */}
              { confirmAction === "OFFER_FAILED" &&
                "Are you sure you want to collect the item from the locker?" }

              { confirmAction === "BUYER_UNSATISFIED" &&
                `Are you sure you want to collect the item from ${ order.buyerName }?` }

              { confirmAction === "BUYER_PLACED_ITEM" &&
                "Are you sure you want to collect the item from the locker?" }

              { confirmAction === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" &&
                `Are you sure you want to transfer payment to ${ order.sellerName }?` }

              { confirmAction === "SUPPORT_PICKED_ITEM_FROM_BUYER" &&
                `Are you sure you want to return item to ${ order.sellerName } or ${ order.buyerName }?` }

              { confirmAction === "SELLER_UNSATISFIED" &&
                `Are you sure you want to collect item from ${ order.sellerName }?` }

              { confirmAction === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED_stepSaller" &&
                `Are you sure you want to transfer payment to ${ order.buyerName }?` }

              { confirmAction === "SUPPORT_PICKED_ITEM_FROM_LOCKER" && (
                <>
                  <div>
                    Are you sure you want to return item to  <strong>Seller:</strong> { order.sellerName }  or  <strong>Buyer:</strong> { order.buyerName } ?
                  </div>
                </>
              ) }
              { confirmAction === "SUPPORT_PICKED_ITEM_FROM_SELLER" && (
                <>
                  <div>
                    Are you sure you want to return item to  <strong>Seller:</strong> { order.sellerName }  or  <strong>Buyer:</strong> { order.buyerName } ?
                  </div>
                </>
              ) }



              { confirmAction === "ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION" &&
                `Are you sure you want to transfer $${ order.itemPrice } to ${ order.sellerName }?` }

              { confirmAction === "SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM" &&
                "Are you sure you want to collect the item from the locker?" }

              { confirmAction === "BUYER_SATISFIED" &&
                `Are you sure you want to transfer $${ order.itemPrice } to ${ order.sellerName }?` }

              { confirmAction === "BUYER_EXTENDED_LOCKER_TIME_FOR_PLACE_ITEM" &&
                `Are you sure you want to collect the item from ${ order.buyerName }?` }

              { confirmAction === "SELLER_PLACED_ITEM_with_BUYER_EXTENDED_LOCKER_TIME" &&
                "Are you sure you want to collect the item from the locker?" }

            </Typography>



            {/* { ( confirmAction === "SUPPORT_PICKED_ITEM_FROM_SELLER" ||
              confirmAction === "SUPPORT_PICKED_ITEM_FROM_LOCKER" || confirmAction === "SUPPORT_PICKED_ITEM_FROM_BUYER" ) && (
                <>
                  <Typography sx={ { mt: 2, mb: 1, fontWeight: 600 } }>
                    Enter OTP
                  </Typography>

                  <Box display="flex" justifyContent="left" gap={ 2 }>

                    <TextField
                      value={ otp }
                      onChange={ ( e ) => {

                        setOtp( e.target.value.replace( /\D/g, "" ) )
                        setOtpError( "" )

                      } }
                      inputProps={ { maxLength: 6 } }
                      fullWidth
                      margin="dense"
                      error={ !!otpError }
                      helperText={ otpError }
                    />

                  </Box>
         
                </>
              ) } */}

            <TextField
              style={ { marginTop: "8px" } }
              label="Remark"
              multiline
              placeholder='Enter remark'
              minRows={ 3 }
              fullWidth
              value={ remark }
              onChange={ ( e ) => setRemark( e.target.value ) }
              variant="outlined"
            />
          </DialogContent>

          <DialogActions sx={ { p: 3, gap: 2 } }>
            {/* Cancel Button */ }
            <Button
              onClick={ () => {
                setConfirmOpen( false )
                setRemark( "" )
              } }
              disabled={ actionLoading }
              variant="outlined"
              sx={ {
                minWidth: 100,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600
              } }
            >
              Cancel
            </Button>

            {/*🆕 Seller Decline button
       Only if offerStatus === support_take_item_from_buyer
    */}
            {/* { order.status === "support_take_item_from_buyer" && (
            <Button
              onClick={ () => {
                handleConfirm( confirmAction );

                setConfirmOpen( false );
              } }
              color="primary"
              variant="contained"
              disabled={ actionLoading }
              sx={ {
                minWidth: 150,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600
              } }
            >
              { actionLoading ? <CircularProgress size={ 24 } /> : "Seller Decline" }
            </Button>
          ) } */}

            {/* Return To Buyer Button (only in seller-decline popup) */ }
            {/* { (
            ( confirmAction === "seller" || confirmAction === "action" ) &&
            order.status === "SELLER_DECLINE"
          ) && (
              <Button
                onClick={ () => {
                  handleConfirmAction();
                  handleConfirm( confirmAction );
                  setConfirmOpen( false );
                } }
                color="primary"
                variant="contained"
                disabled={ actionLoading }
                sx={ {
                  minWidth: 150,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                } }
              >
                { actionLoading ? <CircularProgress size={ 24 } /> : "Return To Buyer" }
              </Button>
            ) } */}

            {/* { (
            ( step === "BUYER_UNSATISFIED" && order.status !== "SELLER_DECLINE" )
            ||
            ( confirmAction === "seller" && step === "BUYER_UNSATISFIED" )
          ) && (
              <Button
                onClick={ () => {
                  handleConfirmAction();
                  handleConfirm( confirmAction );
                  setConfirmOpen( false );
                } }
                color="primary"
                variant="contained"
                disabled={ actionLoading }
                sx={ {
                  minWidth: 150,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                } }
              >
                { actionLoading ? <CircularProgress size={ 24 } /> : "Seller Declined" }
              </Button>
            ) } */}

            {/* Main Action Button (Collect / Return To Seller) */ }
            { ( confirmAction === "BUYER_PLACED_ITEM" || confirmAction === "SELLER_PLACED_ITEM_with_BUYER_EXTENDED_LOCKER_TIME" || confirmAction === "BUYER_EXTENDED_LOCKER_TIME_FOR_PLACE_ITEM" || confirmAction === "SELLER_EXTENDED_LOCKER_TIME_FOR_TAKE_ITEM" || confirmAction === "OFFER_FAILED" || confirmAction === "BUYER_UNSATISFIED" || confirmAction === "SELLER_UNSATISFIED" ) && (
              <Button
                onClick={ () => {
                  handleSupportPickup()
                  setConfirmOpen( false );
                } }
                color="primary"
                variant="contained"
                disabled={ actionLoading }
                sx={ {
                  minWidth: 150,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                } }
              >
                { actionLoading ? (
                  <CircularProgress size={ 24 } />
                ) : (
                  "Collect"
                ) }
              </Button>
            ) }

            {/* Return iton to seller and buyer  */ }
            { ( confirmAction === "SUPPORT_PICKED_ITEM_FROM_SELLER" || confirmAction === "SUPPORT_PICKED_ITEM_FROM_LOCKER" || confirmAction === "SUPPORT_PICKED_ITEM_FROM_BUYER" ) && (
              <>
                {/* Return to Seller */ }
                <Button
                  onClick={ () => {
                    // handleReturnToseller();
                    setOtpContext( {
                      side: "seller",
                      name: order?.sellerName || "Buyer"
                    } );
                    setOtpModel( true )
                    setConfirmOpen( false );
                  } }
                  color="primary"
                  variant="contained"
                  disabled={ actionLoading }
                  sx={ {
                    minWidth: 150,
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    mr: 2,
                  } }
                >
                  { actionLoading ? (
                    <CircularProgress size={ 24 } />
                  ) : (
                    "Return item to Seller"
                  ) }
                </Button>

                {/* Return to Buyer */ }
                <Button
                  onClick={ () => {
                    // handleReturnToBuyer();  
                    setOtpModel( true )
                    setOtpContext( {
                      side: "buyer",
                      name: order?.buyerName || "Buyer"
                    } );

                    setConfirmOpen( false );
                  } }
                  color="primary"
                  variant="contained"
                  disabled={ actionLoading }
                  sx={ {
                    minWidth: 150,
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                  } }
                >
                  { actionLoading ? (
                    <CircularProgress size={ 24 } />
                  ) : (
                    "Return item to Buyer"
                  ) }
                </Button>
              </>
            ) }
            {/* transfer api */ }

            { ( confirmAction === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED_stepSaller" || confirmAction === "BUYER_SATISFIED" || confirmAction === "ITEM_RETURN_TO_BUYER_AFTER_INVESTIGATION" || confirmAction === "ITEM_NOT_SUBMIT_TO_SUPPORT_TIME_EXPIRED" ) && (
              <Button
                onClick={ () => {
                  handleTransfer()
                  setConfirmOpen( false );
                } }
                color="primary"
                variant="contained"
                disabled={ actionLoading }
                sx={ {
                  minWidth: 150,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                } }
              >
                { actionLoading ? (
                  <CircularProgress size={ 24 } />
                ) : (
                  "Transfer"
                ) }
              </Button>
            ) }

          </DialogActions>
        </Dialog>
        <Dialog
          open={ otpModel }
          onClose={ () => {
            setOtpModel( false );
            setRemark( "" );
            setOtp( "" );
            setOtpError( "" );
          } }
          maxWidth="sm"
          fullWidth
        >
          {/* Header */ }
          <DialogTitle
            sx={ {
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              fontWeight: 600,
              py: 2.5,
              px: 3,
            } }
          >
            Enter Transaction Code
          </DialogTitle>

          {/* Content */ }
          <DialogContent sx={ { pt: 3 } }>
            <Typography sx={ { mb: 2 } } style={ { marginTop: "5px" } } >
              Enter the transaction code sent to{ " " }

              { otpContext?.side === "buyer" && "Buyer" }
              { otpContext?.side === "seller" && "Seller" }
              { otpContext?.side === "locker" && "Locker" }
              { " " }
              <strong>{ otpContext?.name }</strong>.
            </Typography>

            { ( confirmAction === "SUPPORT_PICKED_ITEM_FROM_SELLER" ||
              confirmAction === "SUPPORT_PICKED_ITEM_FROM_LOCKER" ||
              confirmAction === "SUPPORT_PICKED_ITEM_FROM_BUYER" ) && (
                <>
                  <Typography sx={ { mb: 1, fontWeight: 600 } }>
                    Enter Transaction Code
                  </Typography>

                  <Box display="flex" justifyContent="left">
                    <TextField
                      type={ showOtp ? "text" : "password" }
                      value={ otp }
                      onChange={ ( e ) => {
                        setOtp( e.target.value.replace( /\D/g, "" ) );
                        setOtpError( "" );
                      } }
                      inputProps={ {
                        maxLength: 6,
                        style: { textAlign: "center", fontSize: 18, letterSpacing: 4 },
                      } }
                      placeholder="••••••"
                      sx={ { width: 260 } }
                      error={ !!otpError }
                      helperText={ otpError }
                      InputProps={ {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={ () => setShowOtp( ( prev ) => !prev ) }
                              edge="end"
                              size="small"
                            >
                              { showOtp ? <VisibilityOff /> : <Visibility /> }
                            </IconButton>
                          </InputAdornment>
                        ),
                      } }
                    />
                  </Box>



                </>
              ) }
          </DialogContent>

          {/* Actions */ }
          <DialogActions sx={ { px: 3, pb: 2 } }>
            <Button
              onClick={ () => {
                setOtpModel( false );
                setRemark( "" );
                setOtp( "" );
                setOtpError( "" );
              } }
              disabled={ actionLoading }
              variant="outlined"
              sx={ {
                minWidth: 100,
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
              } }
            >
              Cancel
            </Button>

            <Button
              onClick={ otpContext?.side === "buyer" ? handleReturnToBuyer : handleReturnToseller }
              disabled={ actionLoading || otp.length < 6 }
              variant="contained"
              sx={ {
                minWidth: 120,
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
              } }
            >
              Verify & Continue
            </Button>
          </DialogActions>
        </Dialog>



      </Box >

      <Snackbar
        open={ toast.open }
        autoHideDuration={ 6000 }
        onClose={ handleCloseToast }
        anchorOrigin={ { vertical: "top", horizontal: "right" } }
        TransitionComponent={ Slide }
      >
        <Alert
          onClose={ handleCloseToast }
          severity={ toast.severity }
          sx={ {
            width: "100%",
            "& .MuiAlert-icon": { alignItems: "center" },
          } }
          icon={
            toast.severity === "warning" ? <CheckCircleIcon /> : undefined
          }
        >
          { toast.message }
        </Alert>
      </Snackbar>

    </>

  );
};

export default OrderDetail;
